import React, { Component } from 'react'
import { Card } from 'react-bootstrap';

import './Styles.css';

class EmpresaInfo extends Component {
  render() {
    const { data = {} } = this.props;

    return (
      <Card>
        <Card.Body>
          <strong className="text-info card-label-info">ID: </strong>
          { data.id }
          <br/>

          <strong className="text-info card-label-info">Empresa: </strong>
          { data.nombre }
          <br/>
        </Card.Body>
      </Card>
    )
  }
}

export default EmpresaInfo;